export enum InputType {
	TEXT = 'text',
	TEXTAREA = 'textArea',
}